import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing-page">

      {/* ---------------- HERO ---------------- */}
      <section className="pricing-hero">
        <h1>MEMBERSHIP</h1>
        <p>Choose your path. Commit to greatness.</p>
        <span className="red-line"></span>
      </section>



      {/* ---------------- PRICING TIERS ---------------- */}
      <section className="pricing-tiers">

        <div className="tier-card basic">
          <h2>BASIC</h2>
          <h3>$29 / month</h3>
          <p className="sub">Perfect for beginners starting their journey.</p>

          <ul>
            <li>Full Gym Access</li>
            <li>Cardio Zone</li>
            <li>Locker Facility</li>
            <li>General Floor Trainer</li>
          </ul>

          <button>Choose Plan</button>
        </div>


        <div className="tier-card elite featured">
          <div className="tag">MOST POPULAR</div>
          <h2>ELITE</h2>
          <h3>$59 / month</h3>
          <p className="sub">For athletes who want structured progression.</p>

          <ul>
            <li>All Basic Benefits</li>
            <li>All Group Classes</li>
            <li>Steam / Sauna</li>
            <li>1:1 Coaching Sessions</li>
          </ul>

          <button>Choose Plan</button>
        </div>


        <div className="tier-card pro">
          <h2>PRO ATHLETE</h2>
          <h3>$99 / month</h3>
          <p className="sub">For competitors & relentless individuals.</p>

          <ul>
            <li>All Elite Benefits</li>
            <li>Unlimited PT Sessions</li>
            <li>Custom Diet + Training Plan</li>
            <li>Priority Support</li>
          </ul>

          <button>Choose Plan</button>
        </div>

      </section>



      {/* ---------------- WHAT'S INCLUDED GRID ---------------- */}
      <section className="includes-section">
        <h1>WHAT’S INCLUDED</h1>

        <div className="includes-grid">

          <div className="inc-item">
            <h3>STATE-OF-THE-ART EQUIPMENT</h3>
            <p>Elite machines designed for maximum output and biomechanics.</p>
          </div>

          <div className="inc-item">
            <h3>FUNCTIONAL TRAINING ARENA</h3>
            <p>Kettlebells, sleds, rigs, battle ropes & explosive training tools.</p>
          </div>

          <div className="inc-item">
            <h3>GROUP CLASSES</h3>
            <p>HIIT, Strength, Endurance, Yoga & Mobility sessions.</p>
          </div>

          <div className="inc-item">
            <h3>LOCKER & SHOWER ACCESS</h3>
            <p>Clean, modern facilities with daily maintenance.</p>
          </div>

          <div className="inc-item">
            <h3>PERSONAL COACHING</h3>
            <p>Expert guidance to boost gains, form & confidence.</p>
          </div>

          <div className="inc-item">
            <h3>NUTRITION CONSULTATION</h3>
            <p>Custom macros, body analysis & tailored plans.</p>
          </div>

        </div>
      </section>



      {/* ---------------- FINAL CTA ---------------- */}
      <section className="pricing-cta">
        <h1>COMMIT TO YOUR EVOLUTION.</h1>
        <button>Join ACE Today</button>
      </section>

    </div>
  );
};

export default Pricing;
